/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from 'primereact/datatable';
import { Calendar } from '../../../../components/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Password } from 'primereact/password';
import { addLocale } from 'primereact/api';
import { get, orderBy } from 'lodash';

import dateFormat from 'dateformat';

import 'react-toastify/dist/ReactToastify.css';

import * as actions from '../../../../store/modules/auth/actions';

import { displayErrors, formataDataMoment } from '../../../../util/diversos';
import { fillColumns } from '../../../../components/table';
import { Input100px, Input155px, Input200px } from '../../../../styles/inputGroup';

import store from '../../../../store/store';
import axiosAdmin from '../../../../services/axiosAdmin';
import Card from '../../../../components/card';
import Loading from '../../../loading';
import CadastroEstampariaOrdemProducao from './cadastroEstampariaOrdemProducao';
import PdfEstampariaOrdemProducao from '../../relatorio/pdfEstampariaOrdemProducao';

export default function ConsultaEstampariaOrdemProducao() {
  const [isLoading, setIsLoading] = useState(false);

  const [showCadastro, setShowCadastro] = useState(false);
  const [showCadastroProdutividade, setShowCadastroProdutividade] = useState(false);
  const [showConfirmDeleteProdutividade, setShowConfirmDeleteProdutividade] = useState(false);
  const [showPrintOrdemProducao, setShowPrintOrdemProducao] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dataTableList, setDataTableList] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  // const [showConfirmDialogAlterarSituacao, setShowConfirmDialogAlterarSituacao] = useState(false);
  const [filtroAtualizado, setFiltroAtualizado] = useState(null);
  const [selectedItens, setSelectedItens] = useState(null);
  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);
  const [findNomePedido, setFindNomePedido] = useState('');
  const [findIdPedido, setFindIdPedido] = useState(0);
  const [findSituacaoPedido, setFindSituacaoPedido] = useState('TODOS');
  const [senhaAdm, setSenhaAdm] = useState(null);
  const [senhaAdmInformada, setSenhaAdmInformada] = useState(null);
  const [sortField, setSortField] = useState('descricao');
  const [sortOrder, setSortOrder] = useState(null);
  const [payloadCadastro, setPayloadCadastro] = useState({});
  const [payloadPrint, setPayloadPrint] = useState({});
  // const [novaSituacao, setNovaSituacao] = useState(null);

  const UseFocus = () => {
    const htmlElRef = useRef(null);
    // eslint-disable-next-line no-unused-expressions
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus(); };

    return [htmlElRef, setFocus];
  };

  const [ordemProdutividadeInclusaoDireta, setOrdemProdutividadeInclusaoDireta] = useState(null);
  const [selectedProdutividade, setSelectedProdutividade] = useState(null);
  const [produtividadeSituacao, setProdutividadeSituacao] = useState(null);
  const [produtividadeQuantidade, setProdutividadeQuantidade] = useState(0);
  const [produtividadeData, setProdutividadeData] = useState(null);
  const [buttonOkProdutividade] = UseFocus();

  const [columnsSetup] = useState([
    { field: 'id', header: 'Número', sort: true },
    { field: 'dataPedido', header: 'Data Pedido', sort: true },
    { field: 'nomePedido', header: 'Nome do Pedido', sort: false },
    { field: 'dataInicioProducao', header: 'Data Início', sort: true },
    { field: 'dataTerminoProducao', header: 'Data Término', sort: false },
    { field: 'garantia', header: 'Garantia', sort: false },
    { field: 'situacao', header: 'Situação', sort: false },
    { field: 'vendedor.nome', header: 'Vendedor', sort: false },
  ]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });
  const [listaSituacaoOrdemProducao] = useState([
    { label: 'Planejada', value: 'PLANEJADA' },
    { label: 'Cortada', value: 'CORTANDO' },
    { label: 'Silkada', value: 'SILKANDO' },
    { label: 'Bordada', value: 'BORDANDO' },
    { label: 'Sublimada', value: 'SUBLIMANDO' },
    { label: 'Arrematada', value: 'ARREMATANDO' },
    { label: 'Finalizada', value: 'FINALIZADA' },
    { label: 'Cancelada', value: 'CANCELADA' },
    { label: 'Todos', value: 'TODOS' },
  ]);

  const [listaSituacaoOrdemProducaoAlteracao] = useState([
    { label: 'Planejada', value: 'PLANEJADA' },
    { label: 'Cortada', value: 'CORTANDO' },
    { label: 'Silkada', value: 'SILKANDO' },
    { label: 'Bordada', value: 'BORDANDO' },
    { label: 'Sublimada', value: 'SUBLIMANDO' },
    { label: 'Arrematada', value: 'ARREMATANDO' },
    { label: 'Finalizada', value: 'FINALIZADA' },
    { label: 'Cancelada', value: 'CANCELADA' },
  ]);

  const [columnsSetupProdutividade] = useState([
    { field: 'data', header: 'Data', sort: true },
    { field: 'processo', header: 'Processo', sort: true },
    { field: 'quantidade', header: 'Quantidade', sort: true },
  ]);

  addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'hoje',
    clear: 'Limpar',
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  async function getData(searchFilter, page, size) {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      // buscar pelo id do pedido
      if (searchFilter && searchFilter.findIdPedido > 0) {
        // Pegar o pedido pelo numero
        const params = `/estampariapedido/${searchFilter.findIdPedido}`;

        const responsePedido = await axiosAdmin.get(params);

        if (responsePedido.data.situacao === 'ABERTO') {
          setDataTableList(responsePedido.data.listaEstampariaOrdemProducao);
        } else {
          // console.log('response pedido: ', responsePedido.data);
          toast.error('Pedido fechado ou não contém ordens de produção.');
          setDataTableList([]);
        }
      } else {
        let params = `/estampariaordemproducao/search?idUsuario=${idUsuario}`;

        if (searchFilter && searchFilter.findDataInicial !== '') {
          const _dataInicial = `${dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy')} 00:00:00`;
          const _dataFinal = `${dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy')} 23:59:59`;

          params = `${params}&dataPedidoInicial=${_dataInicial}&dataPedidoFinal=${_dataFinal}`;
        }

        if (searchFilter && searchFilter.findNomePedido !== '') {
          params = `${params}&nomePedido=${findNomePedido}`;
        }

        if (searchFilter && searchFilter.findSituacaoPedido !== 'TODOS') {
          params = `${params}&situacao=${searchFilter.findSituacaoPedido}`;
        }

        if (searchFilter && searchFilter.findIdPedido > 0) {
          params = `${params}&idPedido=${searchFilter.findIdPedido}`;
        }

        params = `${params}&page=${page}&size=${size}`;

        const response = await axiosAdmin.get(params);

        // console.log('response data: ', response.data.content);

        setFindNomePedido('');

        response.data.content.forEach(el => {
          el.situacao === 'CORTANDO' ? el.situacao = 'CORTADA' : el.situacao;
          el.situacao === 'SILKANDO' ? el.situacao = 'SILKADA' : el.situacao;
          el.situacao === 'BORDANDO' ? el.situacao = 'BORDADA' : el.situacao;
          el.situacao === 'SUBLIMANDO' ? el.situacao = 'SUBLIMADA' : el.situacao;
        });

        setDataTableList(response.data.content);
        setTotalRecords(response.data.totalElements);
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal, findNomePedido, findSituacaoPedido, findIdPedido };

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    getData(searchFilter, 0, lazyParams.rows);
  };

  useEffect(() => {
    async function verificarSeMultiEmpresa(idUsuario, searchFilter) {
      try {
        setIsLoading(true);

        const params = `/usuario/${idUsuario}`;

        await axiosAdmin.get(params);

        getData(searchFilter, 0, lazyParams.rows);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    async function getConfiguracaoSistema() {
      try {
        setIsLoading(true);

        const idUsuario = get(store.getState().auth.user, 'id', 0);

        const params = `/configuracaosistema?idUsuario=${idUsuario}`;

        const response = await axiosAdmin.get(params);

        setSenhaAdm(get(response.data, 'senhaAdm', ''));
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getConfiguracaoSistema();

    if (findDataInicial === null) {
      setFindDataInicial(new Date(store.getState().auth.consultaEstampariaOrdemProducaoDataInicial));
      setFindDataFinal(new Date(store.getState().auth.consultaEstampariaOrdemProducaoDataFinal));

      const _dataInicial = new Date(store.getState().auth.consultaEstampariaOrdemProducaoDataInicial);
      const _dataFinal = new Date(store.getState().auth.consultaEstampariaOrdemProducaoDataFinal);

      const searchFilter = { findDataInicial: _dataInicial, findDataFinal: _dataFinal, findNomePedido, findSituacaoPedido };

      verificarSeMultiEmpresa(get(store.getState().auth.user, 'id', 0), searchFilter);
    }

    if (filtroAtualizado) {
      setFiltroAtualizado(false);
      handleFind();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filtroAtualizado]);

  useEffect(() => {
    if (produtividadeSituacao === 'PLANEJADA' || produtividadeSituacao === 'FINALIZADA' || produtividadeSituacao === 'CANCELADA') {
      setProdutividadeQuantidade(0);
    }
  }, [produtividadeSituacao]);

  const handleRegister = () => {
    const id = 0;

    setPayloadCadastro({ id });

    setShowCadastro(true);
  };

  const handleEdit = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      const geracaoAutomatica = get(selectedItens, 'geracaoAutomatica', false);

      if (geracaoAutomatica) {
        toast.error('Ordem de Produção gerada através do Pedido não pode ser alterada');
      } else {
        setPayloadCadastro({ id });
        setShowCadastro(true);
      }
    } else {
      toast.warning('Por favor, selecione o registro para edição');
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setSenhaAdmInformada(null);

      setShowConfirmDialog(true);
    } else {
      toast.warning('Por favor, selecione o registro para exclusão');
    }
  };

  /* const handleAlterarSituacao = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setSenhaAdmInformada(null);
      setNovaSituacao(get(selectedItens, 'situacao', 'PLANEJADA'));

      setShowConfirmDialogAlterarSituacao(true);
    } else {
      toast.warning('Por favor, selecione o registro para exclusão');
    }
  };

  const cancelAlterarSituacao = () => {
    setShowConfirmDialogAlterarSituacao(false);
  };

  const confirmAlterarSituacao = async () => {
    setShowConfirmDialogAlterarSituacao(false);

    try {
      setIsLoading(true);

      const idAlteracaoSituacao = get(selectedItens, 'id', 0);

      if (idAlteracaoSituacao > 0) {
        await axiosAdmin.put(`/estampariaordemproducao/alterarsituacao/${idAlteracaoSituacao}?situacao=${novaSituacao}`);

        const searchFilter = { findDataInicial, findDataFinal, findNomePedido, findSituacaoPedido, findIdPedido };

        getData(searchFilter, 0, lazyParams.rows);

        setSelectedItens(null);

        toast.success('Registro alterado com sucesso');
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível alterar o registro');
    } finally {
      setIsLoading(false);
    }
  };
  */

  /* const confirmDialogFooterAlterarSituacao = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmAlterarSituacao} />
      <Button label="Não" icon="pi pi-times" onClick={cancelAlterarSituacao} />
    </div>
  ); */

  const cancelDelete = () => {
    setShowConfirmDialog(false);
  };

  const confirmDelete = async () => {
    if (senhaAdmInformada !== senhaAdm) {
      setSenhaAdmInformada(null);

      toast.error('Senha inválida!');

      return;
    }

    setSenhaAdmInformada(null);

    setShowConfirmDialog(false);

    try {
      setIsLoading(true);

      const idExclusao = get(selectedItens, 'id', 0);

      if (idExclusao > 0) {
        await axiosAdmin.delete(`/estampariaordemproducao/${idExclusao}`);

        const searchFilter = { findDataInicial, findDataFinal, findNomePedido, findSituacaoPedido, findIdPedido };

        getData(searchFilter, 0, lazyParams.rows);

        toast.success('Registro excluído com sucesso');
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível excluir o registro');
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDialogFooter = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDelete} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDelete} />
    </div>
  );

  const onSort = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    setDataTableList(orderBy(dataTableList, [sortField], [sortOrder]));
  };

  const onPage = (event) => {
    setLazyParams(event);

    const searchFilter = { findDataInicial, findDataFinal, findNomePedido, findSituacaoPedido, findIdPedido };

    getData(searchFilter, event.page, event.rows);
  };

  const onHideCadastro = () => {
    setShowCadastro(false);
  };

  const childToParentCadastro = (payloadDataTableList, id) => {
    if (payloadDataTableList) {
      if (id > 0) {
        const searchFilter = { findDataInicial, findDataFinal, findNomePedido, findSituacaoPedido, findIdPedido };

        getData(searchFilter, lazyParams.page, lazyParams.rows);
      } else {
        const _dataTableList = [];
        _dataTableList.push(payloadDataTableList);

        setDataTableList(_dataTableList);

        const _lazyParams = { ...lazyParams, first: 0, page: 0 };
        setLazyParams(_lazyParams);
        setTotalRecords(1);
      }
    }

    setShowCadastro(false);
  };

  const handlePrintOrdemProducao = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setPayloadPrint({ id });
      setShowPrintOrdemProducao(true);
    } else {
      toast.warning('Por favor, selecione o registro para edição');
    }
  };

  const onHidePrintOrdemProducao = () => {
    setShowPrintOrdemProducao(false);
  };

  const finishPrintOrdemProducao = () => {
    setShowPrintOrdemProducao(false);
  };

  const handleFindEnterNumeroPedido = (idPedidoEnter) => {
    const searchFilter = { findDataInicial, findDataFinal, findNomePedido, findSituacaoPedido, findIdPedido };

    // eslint-disable-next-line no-unused-expressions
    idPedidoEnter = idPedidoEnter.replace('.', '');
    if (idPedidoEnter > 0) { searchFilter.findIdPedido = idPedidoEnter; }

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    getData(searchFilter, 0, lazyParams.rows);
  };

  const onHideCadastroProdutividade = () => {
    setShowCadastroProdutividade(false);
  };

  const limpaCamposCadastroProdutividade = () => {
    setProdutividadeData(null);
    setProdutividadeSituacao(null);
    setProdutividadeQuantidade(0);
  };

  // eslint-disable-next-line consistent-return
  const handleAdicionarProdutividade = async (e) => {
    e.preventDefault();

    limpaCamposCadastroProdutividade();

    if (selectedItens === null) {
      toast.info('Ordem de Produção nao selecionada.');
      return false;
    }

    // console.log('selectedItens: ', selectedItens);

    const id = get(selectedItens, 'id', 0);
    // const status = get(selectedItens, 'situacao', null);

    /* if (status === 'CANCELADA' || status === 'FINALIZADA' || status === 'FECHADA' || status === 'PLANEJADA') {
      toast.info(`Ordem de Produção ${status} não pode adicionar produtividade.`);
      return false;
    } */

    if (id > 0) {
      const paramsOrdem = `/estampariaordemproducaoprodutividade/obterporidestampariaordemproducao?id=${id}`;
      const responseOrdem = await axiosAdmin.get(paramsOrdem);

      // console.log('lista produtividade: ', responseOrdem.data);

      const _listaProdutividade = responseOrdem.data;

      let contadorItem = 1;
      _listaProdutividade.forEach(el => {
        el.item = contadorItem++;
      });

      setOrdemProdutividadeInclusaoDireta(_listaProdutividade);

      setProdutividadeData(new Date());

      setShowCadastroProdutividade(true);
    } else {
      toast.warning('Por favor, selecione o registro inclusão do produto');
    }
  };

  // eslint-disable-next-line consistent-return
  const handleDeleteProdutividade = (e) => {
    e.preventDefault();

    const produtividade = get(selectedProdutividade, 'item', 0);

    if (produtividade > 0) {
      const _produtividadeSelecionado = ordemProdutividadeInclusaoDireta.find(element => element.item === produtividade);

      if (!_produtividadeSelecionado) {
        toast.warning('Por favor, selecione o prduto para exclusão');
        return false;
      }

      setShowConfirmDeleteProdutividade(true);
    } else {
      toast.warning('Por favor, selecione o produto para exclusão');
    }
  };

  const confirmDeleteProdutividade = async () => {
    const produtividade = get(selectedProdutividade, 'item', 0);

    if (produtividade > 0) {
      try {
        setIsLoading(true);

        // console.log('selected produtividade: ', selectedProdutividade);

        const idExclusao = get(selectedProdutividade, 'id', 0);

        if (idExclusao > 0) {
          await axiosAdmin.delete(`/estampariaordemproducaoprodutividade/${idExclusao}`);

          const searchFilter = { findDataInicial, findDataFinal, findNomePedido, findSituacaoPedido, findIdPedido };

          getData(searchFilter, 0, lazyParams.rows);

          toast.success('Registro excluído com sucesso');

          const _listaProdutividade = ordemProdutividadeInclusaoDireta;

          const index = _listaProdutividade.indexOf(_listaProdutividade.find(element => element.item === produtividade));

          if (index >= 0) {
            _listaProdutividade.splice(index, 1);

            _listaProdutividade.forEach(element => {
              if (element.item > produtividade) {
                const _index = _listaProdutividade.indexOf(element);

                _listaProdutividade[_index].item = _listaProdutividade[_index].item - 1;
              }
            });

            setSelectedProdutividade(null);

            console.log('produtividadeSituacao: ', produtividadeSituacao);
            console.log('selected ordem producao: ', selectedItens);
            if (_listaProdutividade.length <= 0 && selectedItens.situacao !== 'CANCELADA') {
              await axiosAdmin.put(`/estampariaordemproducao/alterarsituacao/${selectedItens.id}?situacao=PLANEJADA`);
            }

            setOrdemProdutividadeInclusaoDireta(_listaProdutividade);
            setShowConfirmDeleteProdutividade(false);

            handleFind();
          }
        }
      } catch (err) {
        displayErrors(err, dispatch, navigate, '', 'Não foi possível excluir o registro');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const cancelDeleteProdutividade = () => {
    setSelectedProdutividade(null);
    setShowConfirmDeleteProdutividade(false);
  };

  const confirmDialogFooterProdutividade = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDeleteProdutividade} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDeleteProdutividade} />
    </div>
  );

  const handleOkProdutividade = async () => {
    if (produtividadeData === null) {
      toast.info('Data da produtividade nao informada');
      return false;
    }

    if (produtividadeSituacao === null) {
      toast.info('Situação da produtividade nao informada');
      return false;
    }

    // console.log('produtividade situacao: ', produtividadeSituacao);
    if (produtividadeSituacao !== 'PLANEJADA' && produtividadeSituacao !== 'CANCELADA' && produtividadeSituacao !== 'FINALIZADA') {
      if (produtividadeQuantidade <= 0) {
        toast.info('Quantidade da produtividade nao informada');
        return false;
      }
    }

    let existeProdutividade = false;
    ordemProdutividadeInclusaoDireta.forEach(el => {
      if (el.processo === produtividadeSituacao) {
        existeProdutividade = true;
      }
    });

    if (existeProdutividade) {
      toast.info(`Situação da produtividade ${produtividadeSituacao} já informada.`);
      return false;
    }

    let _data = null;
    if (produtividadeData) {
      _data = formataDataMoment(produtividadeData, '-', true);
    }

    try {
      setIsLoading(true);

      setShowCadastroProdutividade(false);

      const idOrdemProducaoSelecionada = get(selectedItens, 'id', 0);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      const itens = [];
      let contadorItem = 0;

      // console.log('produtividade direta: ', ordemProdutividadeInclusaoDireta);

      ordemProdutividadeInclusaoDireta.forEach(el => {
        contadorItem = contadorItem + 1;
        itens.push({
          item: contadorItem,
          data: el.data,
          situacao: el.situacao,
          quantidade: el.quantidade,
        });
      });

      const shippingData = {
        data: _data,
        idUsuario,
        processo: produtividadeSituacao,
        quantidade: produtividadeQuantidade,
        idOrdemProducao: idOrdemProducaoSelecionada,
      };

      // console.log('shippingData inclusao direta: ', shippingData);

      if (produtividadeSituacao !== 'PLANEJADA' && produtividadeSituacao !== 'CANCELADA' && produtividadeSituacao !== 'FINALIZADA') {
        await axiosAdmin.post('/estampariaordemproducaoprodutividade', shippingData);
      }

      await axiosAdmin.put(`/estampariaordemproducao/alterarsituacao/${idOrdemProducaoSelecionada}?situacao=${produtividadeSituacao}`);

      setSelectedItens(null);
      toast.success('Produtividade/Situação atualizada com sucesso');

      handleFind();

      setOrdemProdutividadeInclusaoDireta([]);

      limpaCamposCadastroProdutividade();
      setShowCadastroProdutividade(false);
    } catch (err) {
      console.log('err: ', err);
      setShowCadastroProdutividade(true);
      displayErrors(err, dispatch, navigate, '', 'Não foi possível atualizar o registro');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Dialog
        header="Inclusão Produtividade"
        visible={showCadastroProdutividade}
        style={{ width: '80vw' }}
        onHide={() => onHideCadastroProdutividade()}
      >
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Ordem Produção
              </Input155px>
              <InputNumber
                disabled
                value={selectedItens ? selectedItens.id : 0}
              />
            </div>
          </div>
          <div className="col-8">
            <div className="p-inputgroup">
              <InputText
                disabled
                value={selectedItens ? selectedItens.nomePedido : ''}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="estamparia-pedido-item">
            <DataTable
              header="Produtividade"
              value={ordemProdutividadeInclusaoDireta}
              size="small"
              stripedRows
              responsiveLayout="scroll"
              selection={selectedProdutividade}
              sortField="item"
              selectionMode="single"
              onSelectionChange={e => setSelectedProdutividade(e.value)}
              selectableRows
              dataKey="item"
              emptyMessage="Nenhum Item cadastrado"
            >
              {fillColumns(columnsSetupProdutividade)}
            </DataTable>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              title="Excluir Produtividade"
              className="btn btn-danger"
              style={{ borderRadius: '15px' }}
              onClick={(e) => handleDeleteProdutividade(e)}
            >
              <i className="pi pi-trash"></i>
            </button>
          </div>
        </div>
        <div className="row form-elo">
          <hr></hr>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Data Produtividade
              </Input155px>
              <Calendar
                id="mask"
                showIcon
                showTime
                showSeconds
                hourFormat="24"
                mask="99/99/9999 99:99:99"
                dateFormat="dd/mm/yy"
                showButtonBar
                showOnFocus={false}
                locale="pt-BR"
                value={produtividadeData}
                onChange={(e) => setProdutividadeData(e.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Situação
              </Input155px>
              <Dropdown
                options={listaSituacaoOrdemProducaoAlteracao}
                value={produtividadeSituacao}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={(e) => setProdutividadeSituacao(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Quantidade
              </Input155px>
              <InputNumber
                mode="decimal"
                inputId="minmaxfraction"
                minFractionDigits={0}
                maxFractionDigits={0}
                value={produtividadeQuantidade}
                onValueChange={e => setProdutividadeQuantidade(e.target.value)}
                onFocus={(e) => e.target.select()}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              ref={buttonOkProdutividade}
              type="button"
              className="btn btn-success"
              title="OK - Inclusão Produtividade"
              onClick={handleOkProdutividade}
            >
              <i className="pi pi-check"></i>
              Ok
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowCadastroProdutividade(false)}
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        header=""
        closeOnEscape={false}
        visible={showCadastro}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastro()}
        className="dialog-cadastro"
      >
        <CadastroEstampariaOrdemProducao payloadCadastro={payloadCadastro} childToParentCadastro={childToParentCadastro} />
      </Dialog>

      <Dialog
        header=""
        visible={showPrintOrdemProducao}
        style={{ width: '98vw' }}
        onHide={() => onHidePrintOrdemProducao()}
        className="dialog-cadastro"
      >
        <PdfEstampariaOrdemProducao payloadPrint={payloadPrint} finishPrintOrdemProducao={finishPrintOrdemProducao} />
      </Dialog>

      <Card>
        <div>
          <div className="card mb-3">
            <h6 className="card-header" style={{ textAlign: 'center' }}>
              ORDEM DE PRODUÇÃO
            </h6>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Data inicial
                </Input100px>
                <Calendar
                  id="mask"
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={findDataInicial}
                  onChange={(e) => {
                    setFindDataInicial(e.value);
                    const consultaEstampariaOrdemProducaoDataInicial = e.value;
                    const consultaEstampariaOrdemProducaoDataFinal = findDataFinal;
                    dispatch(actions.consultaEstampariaOrdemProducaoDataInicialChange({ consultaEstampariaOrdemProducaoDataInicial, consultaEstampariaOrdemProducaoDataFinal }));
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Data final
                </Input100px>
                <Calendar
                  id="mask"
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={findDataFinal}
                  onChange={(e) => {
                    setFindDataFinal(e.value);
                    const consultaEstampariaOrdemProducaoDataInicial = findDataInicial;
                    const consultaEstampariaOrdemProducaoDataFinal = e.value;
                    dispatch(actions.consultaEstampariaOrdemProducaoDataInicialChange({ consultaEstampariaOrdemProducaoDataInicial, consultaEstampariaOrdemProducaoDataFinal }));
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Situação
                </Input100px>
                <Dropdown
                  options={listaSituacaoOrdemProducao}
                  value={findSituacaoPedido}
                  emptyMessage="Nenhum registro a ser exibido"
                  onChange={(e) => setFindSituacaoPedido(e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <button
                type="button"
                title="Buscar"
                className="btn btn-success"
                style={{ borderRadius: '15px' }}
                onClick={handleFind}
              >
                <i className="pi pi-search"></i>
              </button>
              <button
                type="button"
                title="Cadastrar"
                className="btn btn-primary"
                style={{ borderRadius: '15px' }}
                onClick={handleRegister}
              >
                <i className="pi pi-plus"></i>
              </button>
              <button
                type="button"
                title="Editar"
                className="btn btn-warning"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleEdit(e)}
              >
                <i className="pi pi-pencil"></i>
              </button>
              { /* <button
                type="button"
                title="Alterar Situação"
                className="btn btn-secondary"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleAlterarSituacao(e)}
              >
                <i className="pi pi-sync"></i>
              </button> */}
              <button
                type="button"
                title="Adicionar Produtividade"
                className="btn btn-secondary"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleAdicionarProdutividade(e)}
              >
                <i className="pi pi-bookmark"></i>
              </button>
              <button
                type="button"
                title="Excluir"
                className="btn btn-danger"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleDelete(e)}
              >
                <i className="pi pi-trash"></i>
              </button>
              <button
                type="button"
                title="Imprimir Ordem de Produção"
                className="btn btn-dark"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handlePrintOrdemProducao(e)}
              >
                <i className="pi pi-eye"></i>
              </button>
            </div>
          </div>
          <br />
          <div className="row align-items-center">
            <div className="col-9">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Nome do Pedido
                </Input155px>
                <InputText
                  maxLength={100}
                  value={findNomePedido}
                  onChange={e => setFindNomePedido(e.target.value)}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Nº Pedido
                </Input155px>
                <InputNumber
                  inputId="minmaxfraction"
                  minFractionDigits={0}
                  value={findIdPedido}
                  onValueChange={e => setFindIdPedido(e.target.value)}
                  onKeyDown={async (e) => {
                    if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                      handleFindEnterNumeroPedido(e.target.value);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row align-items-center" style={{ marginTop: '10px' }}>
          </div>
        </div>
        <br />

        <div className="card">
          <DataTable
            value={dataTableList}
            size="small"
            stripedRows
            responsiveLayout="scroll"
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            selectionMode="single"
            selection={selectedItens}
            onSelectionChange={e => setSelectedItens(e.value)}
            selectableRows
            dataKey="id"
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            totalRecords={totalRecords}
            onPage={onPage}
            emptyMessage="Nenhum registro a ser exibido"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="{currentPage} de {totalPages}"
            rowsPerPageOptions={[10, 25, 50]}
          >
            {fillColumns(columnsSetup)}
          </DataTable>
        </div>

        <Dialog
          header="Atenção"
          visible={showConfirmDialog}
          style={{ width: '50vw' }}
          footer={confirmDialogFooter}
          onHide={() => setShowConfirmDialog(false)}
        >
          <div className="row form-elo">
            <div className="col-12">
              <div className="p-inputgroup">
                <Input200px className="p-inputgroup-addon">
                  Senha Administrador
                </Input200px>
                <Password
                  autoFocus
                  toggleMask
                  feedback={false}
                  id="inputSenha"
                  value={senhaAdmInformada}
                  onChange={e => setSenhaAdmInformada(e.target.value)}
                />
              </div>
            </div>
          </div>
          <p>
            Todas as Ordens de Produção relacionadas ao Pedido serão excluídas, deseja continuar?
          </p>
        </Dialog>

        { /* <Dialog
          header="Alterar Situação"
          visible={showConfirmDialogAlterarSituacao}
          style={{ width: '50vw' }}
          footer={confirmDialogFooterAlterarSituacao}
          onHide={() => setShowConfirmDialogAlterarSituacao(false)}
        >
          <div className="row form-elo">
            <div className="col-12">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Situação
                </Input155px>
                <Dropdown
                  options={listaSituacaoOrdemProducaoAlteracao}
                  value={novaSituacao}
                  emptyMessage="Nenhum registro a ser exibido"
                  onChange={(e) => setNovaSituacao(e.target.value)}
                />
              </div>
            </div>
          </div>
          <p>
            Deseja alterar a situação da ordem de produção?
          </p>
        </Dialog> */ }

        <Dialog
          header="Confirmação"
          visible={showConfirmDeleteProdutividade}
          style={{ width: '50vw' }}
          footer={confirmDialogFooterProdutividade}
          onHide={() => setShowConfirmDeleteProdutividade(false)}
        >
          <p>
            Excluir o item?
          </p>
        </Dialog>

      </Card>

    </>
  );
}
